import {useLoggedInUserPermissions} from '../../hooks/useLoggedInUser'
import {Permission} from '../../modules/LoggedInUser'

export const useAdminPilotUser = (loggedInUserPermissions?: Permission[] | null) => {
  const loggedInUserPermissionsData = useLoggedInUserPermissions(loggedInUserPermissions)
  return loggedInUserPermissionsData.some(
    (permission: Permission) =>
      permission.permissionType === 'VIEW_USERS' &&
      (!!permission.dataScope.payerId ||
        !!permission.dataScope.payerIds ||
        !!permission.dataScope.customerId ||
        !!permission.dataScope.customerIds)
  )
}
